export const PRICING = {
  MONTHLY: {
    price: 99,
    currency: 'MXN',
    period: 'mes',
    label: 'Mensual - $99 MXN/mes',
  },
  ANNUAL: {
    price: 999,
    currency: 'MXN',
    period: 'año',
    label: 'Anual - $999 MXN/año (Ahorra 16%)',
    savings: '16%',
    monthlyEquivalent: 83,
  },
} as const;
